import { Directive, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { MediaObserver } from '@angular/flex-layout';
import { CoreMediaService } from '../../../@core/services/media.service';
import { TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { FilterManagerService } from './filter-manager.service';

@Directive()
export abstract class BaseFilterContainerComponent implements OnInit, OnDestroy {
  protected ngUnsubscribe = new Subject<void>();
  sidebarOpen = false;
  appliedFilters: any = {};
  isMobile: boolean;
  mobileFilterOpen = false;
  mobileButtonText = '';
  hasFiltersApplied = false;

  @Input() itemCount: number;
  @Input() itemType: string;

  @Output() changeFilters = new EventEmitter();
  @Output() applyFilters = new EventEmitter();
  @Output() resetFilters = new EventEmitter();

  constructor(
    protected mediaObserver: MediaObserver,
    protected coreMediaService: CoreMediaService,
    protected translateService: TranslateService,
    protected router: Router,
    protected filterManager: FilterManagerService
  ) {}

  abstract getQueryParamKeys(): string[];

  ngOnInit(): void {
    this.mobileButtonText = this.translateService.instant('BENEFITS_FILTER.ADD_FILTERS');
    this.subscribeToScreenChanges();
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  toggleSidebar(state: boolean): void {
    this.mobileFilterOpen = state;
    this.sidebarOpen = state;
  }

  applyFiltersBtnClicked(): void {
    this.applyFilters.emit();
  }

  updateMobileFilterTriggerInfo(): void {
    const keys = this.getQueryParamKeys();
    const hasAny = keys.some(key => this.appliedFilters[key]?.length > 0);

    if (hasAny) {
      this.hasFiltersApplied = true;
      this.mobileButtonText = this.translateService.instant('BENEFITS_FILTER.WITH_FILTERS');
    } else {
      this.hasFiltersApplied = false;
      this.mobileButtonText = this.translateService.instant('BENEFITS_FILTER.ADD_FILTERS');
    }
  }

  emitFilters(filters: any): void {
    this.appliedFilters = { ...this.appliedFilters, ...filters };
    this.changeFilters.emit(filters);
    this.updateMobileFilterTriggerInfo();
  }

  onResetAllFilters(): void {
    this.appliedFilters = {};
    this.filterManager.resetAllFilters();
    this.resetFilters.emit();
    this.cleanUrlParams();
    this.updateMobileFilterTriggerInfo();
  }

  protected cleanUrlParams(): void {
    const queryParams: any = {};
    this.getQueryParamKeys().forEach(key => queryParams[key] = null);
    this.router.navigate([], {
      queryParams,
      queryParamsHandling: 'merge'
    });
  }

  private subscribeToScreenChanges(): void {
    this.coreMediaService.onMediaUpdate
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(() => {
        this.isMobile = this.mediaObserver.isActive('bs-lt-lg');
      });
  }
}
